import type { PropsWithChildren } from 'react';
import type { Props as BlockProps } from './Block';
import Block from './Block';
import styled from 'styled-components';
import CircleInfoIcon from '@shared/components/icons/CircleInfo';
import type theme from '@shared/theme';

type Props = BlockProps & {
    $backgroundColor?: keyof typeof theme.colors;
    $textColor?: keyof typeof theme.colors;
    $fillColor?: keyof typeof theme.colors;
    $strokeColor?: keyof typeof theme.colors;
    $size?: 'small' | 'medium';
};

export const Notice = ({
    children,
    $fillColor = 'white',
    $strokeColor = 'uNavy',
    $size = 'small',
    ...props
}: PropsWithChildren<Props>) => {
    return (
        <StyledNotice {...props} $size={$size}>
            <CircleInfoIcon
                height={$size === 'small' ? 18 : 24}
                width={$size === 'small' ? 18 : 24}
                fillColor={$fillColor}
                strokeColor={$strokeColor}
                iColor={$strokeColor}
            />
            {children}
        </StyledNotice>
    );
};

const StyledNotice = styled(Block)<Props>`
    background-color: ${({ theme, $backgroundColor }) =>
        $backgroundColor ? theme.colors[$backgroundColor] : theme.colors.white};
    color: ${({ theme, $textColor }) =>
        $textColor ? theme.colors[$textColor] : theme.colors.uNavy};
    padding: ${({ $size }) => ($size === 'small' ? '8px' : '16px')};
    display: flex;
    align-items: center;
    border-radius: 8px;

    & > svg {
        margin-right: ${({ $size }) => ($size === 'small' ? '8px' : '16px')};
        flex-shrink: 0;
    }
`;
